import _regeneratorRuntime from "C:/Users/hujun/Desktop/front-end/GLP-PC/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "C:/Users/hujun/Desktop/front-end/GLP-PC/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import request from '@/utils/request';
import { expertInstitution } from '@/api';
export default {
  data: function data() {
    return {
      popupVisible: false,
      context: "",
      right: "",
      showLogo: false,
      popupImg: ''
    };
  },
  watch: {
    "$store.state.showNavLogo": {
      handler: function handler(newVal, oldVal) {
        // console.log("变化后的值", newVal);
        // console.log("变化前的值", oldVal);
        this.showLogo = newVal;
      },
      deep: true
    }
  },
  methods: {
    showPopup: function showPopup(type) {
      this.popupVisible = true;
      this.context = type === 1 ? "微信扫描GLP-1助手小程序二维码" : "微信扫描客服二维码，进行在线咨询";
      this.right = type === 1 ? "170px" : "26px";
      this.popupImg = type === 1 ? this.scanImg.miniProgramImg : this.scanImg.customerServiceImg;
    },
    queryExpertInstitution: function queryExpertInstitution() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return request.get(expertInstitution);
            case 2:
              res = _context.sent;
              if (!(res.code != 0 || !res.obj)) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              _this.scanImg = {
                miniProgramImg: res.obj.miniProgramImg,
                customerServiceImg: res.obj.customerServiceImg
              };
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  },
  created: function created() {
    this.queryExpertInstitution();
  }
};